import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import LinkButton from '../LinkButton';
import TypographyDraft from '../TypographyDraft';
import { getTextColorsFromSection } from '../lib/colors';
import Image from '../Image';
import Section from '../Section';

function HeaderSection({ classes, event, site, section }) {
  const buttons = (section.data.buttons || []).slice(0, 2);
  const { styles, data } = section;

  const image = data.image && data.image.url;
  const colors = getTextColorsFromSection(site, section);
  const siteHasMenu = site.sections.some(s => s.type === 'menu');

  return (
    <Section
      site={site}
      section={section}
      rootClassName={classNames(siteHasMenu && classes.rootWithMenu)}
      className={classes.content}
    >
      {image && <Image src={image} alt="" className={classes.image} />}
      <div className={classNames(classes.headerDetails, !image && classes.centeredText)}>
        <TypographyDraft
          component="h1"
          style={{ ...colors.title, ...styles.title }}
          data={data.title}
        />

        <TypographyDraft
          component="h2"
          style={{ ...colors.title, ...styles.subtitle }}
          data={data.subtitle}
          paragraph
        />
        <TypographyDraft style={{ ...colors.text, ...styles.date }} data={data.date} />
        <TypographyDraft style={{ ...colors.text, ...styles.location }} data={data.location} />
        <div className={classNames(classes.buttonsWrapper, !image && classes.centeredButtons)}>
          {buttons.map((button, i) => (
            <LinkButton
              key={i}
              className={classes.button}
              section={section}
              site={site}
              event={event}
              button={button}
              style={styles.buttons && styles.buttons[i]}
            >
              {button.title}
            </LinkButton>
          ))}
        </div>
      </div>
    </Section>
  );
}

HeaderSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  rootWithMenu: {
    [theme.breakpoints.down('md')]: {
      marginTop: 64,
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    padding: 8 * theme.spacing.unit,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  image: {
    width: 320,
    height: 320,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: 200,
      height: 200,
      marginBottom: 5 * theme.spacing.unit,
    },
  },
  headerDetails: {
    display: 'flex',
    flexShrink: 1,
    flexDirection: 'column',
    width: '100%',
    '& h1': {
      marginBottom: theme.spacing.unit,
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 320,
      maxWidth: 560 + 3 * theme.spacing.unit,
      marginLeft: 6 * theme.spacing.unit,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: 0,
      alignItems: 'center',
      textAlign: 'center',
      '& h1': {
        fontSize: 36,
      },
      '& h2': {
        fontSize: 28,
      },
      '& p': {
        fontSize: 20,
      },
    },
    [theme.breakpoints.down('sm')]: {
      '& h1': {
        fontSize: 36,
        marginBottom: 3 * theme.spacing.unit,
      },
      '& h2': {
        display: 'none',
      },
    },
  },
  centeredText: {
    textAlign: 'center',
  },
  buttonsWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
  },
  centeredButtons: {
    justifyContent: 'center',
  },
  button: {
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 280,
    },
    '& + &': {
      [theme.breakpoints.up('md')]: {
        marginLeft: 3 * theme.spacing.unit,
      },
    },
  },
});

export default injectSheet(stylesheet)(HeaderSection);



// WEBPACK FOOTER //
// ./src/site-render/src/HeaderSection/HeaderSection.js